<template>
    <b-button-group :id="iterator.id">
        <slot></slot>
        <router-link v-if="showAudit" if="showAudit" data-original-title title="Auditar" class="btn btn-primary btn-link" tag="button" :to="toAudit">
            <i class="material-icons">find_in_page</i>
        </router-link>
        <router-link v-if="showEdit" if="showEdit" data-original-title title="Editar" class="btn btn-success btn-link" tag="button" :to="toEdit">
            <i class="material-icons">edit</i>
        </router-link>
        <b-button v-if="showRemove" if="showRemove" title="Excluir" class="btn btn-danger btn-link" v-on:click="remove">
            <i class="material-icons">close</i>
        </b-button>
    </b-button-group>
</template>

<script>
    export default {
        props: ['iterator', 'showAudit', 'toAudit', 'showEdit', 'toEdit', 'showRemove', 'dispatchRemove', 'callbackRemove'],
        methods: {
            remove: function () {
                var dispatch = this.dispatchRemove;
                var iterator = this.iterator;
                var self = this;

                self.$dialog.confirm('Deseja realmente remover o item "' + (iterator.name || iterator.status || iterator.description) + '"?')
                        .then(function () {
                            self.$root.$emit('onLoading');

                            // console.log('dispatch, iterator', dispatch, iterator);
                            const response = self.$store.dispatch(dispatch, iterator);

                            response.then(function () {
                                self.$root.$emit('onLoading');
                                self.$notify.success("Item excluído com sucesso!");
                                self.callbackRemove();
                            });

                            response.catch(function () {
                                self.$root.$emit('onLoading');
                                self.$notify.danger("Não foi possível excluir o item!");
                            });
                        });
            }
        }
    };
</script>
